import React from "react";
import Button from "./Button";
import { withStyles } from "@material-ui/core/styles";

const styles = theme => ({
  root: {
    color: "rgb(68,68,68)",
    "&:hover": {
      backgroundColor: "rgba(68,68,68,0.08)"
    }
  }
});

const ToolbarButton = ({ classes, children, ...props }) => (
  <Button className={classes.root} textTransform="capitalize" {...props}>
    {children}
  </Button>
);

export default withStyles(styles)(ToolbarButton);



// WEBPACK FOOTER //
// ./src/components/Buttons/ToolbarButton.js